const aiChatFeedbackSheetStyles = {
  //the chat input's send Fab carries theme.zIndex.fab by default, so backdrop and sheet must stack above it
  backdrop: {
    position: "absolute",
    zIndex: "modal",
  },
  paper: {
    position: "absolute",
    right: 0,
    bottom: 0,
    left: 0,
    zIndex: "modal",
    maxHeight: "80%",
    overflowY: "auto",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  content: {
    padding: "1rem",
  },
};

export default aiChatFeedbackSheetStyles;
